import React from 'react'
import {Modal, Button} from 'react-bootstrap'
import {useAppIntl} from '../../../../i18n'

function ConfirmEndQuiz({
  show,
  handleClose,
  handleConfirm,
  answeredCount,
  questionCount,
  isLoading = false,
  error = null,
}) {
  const {formatMessage} = useAppIntl()
  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{formatMessage({id: 'classes.quiz.end.title'})}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error ? (
          <div className='mb-lg-15 alert alert-danger'>
            <div className='alert-text font-weight-bold'>{error}</div>
          </div>
        ) : (
          ''
        )}
        <div>
          {formatMessage(
            {id: 'classes.quiz.end.body'},
            {answered: answeredCount, total: questionCount}
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={handleClose} disabled={isLoading}>
          {formatMessage({id: 'common.action.cancel'})}
        </Button>
        <Button variant='primary' onClick={handleConfirm} disabled={isLoading}>
          {formatMessage({id: 'common.action.confirm'})}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export {ConfirmEndQuiz}
